import React from "react";
import { Paragraph, Icon } from "@tvg/design-system";
import { WarningContainer, WarningWrapper } from "./styled-components";
import { MtpWarningProps } from "./types";

const MTPWarning = ({ mtp, status, isBetSlipExpanded }: MtpWarningProps) => (
  <>
    {mtp >= 0 && mtp <= 5 && status !== "SK" && (
      <WarningContainer isBetSlipExpanded={isBetSlipExpanded}>
        <WarningWrapper>
          <Icon
            name="warning"
            size="s"
            lineColor="red.700"
            backgroundColor="red.100"
            mr="space-4"
          />
          <Paragraph
            qaLabel="mtp-warning-text"
            fontFamily="bold"
            fontSize="s"
            color="red.700"
          >
            {`${mtp}m `}
          </Paragraph>
          <Paragraph
            qaLabel="warning-text"
            fontFamily="regular"
            fontSize="s"
            color="red.700"
          >
            - The race is starting soon
          </Paragraph>
        </WarningWrapper>
      </WarningContainer>
    )}
  </>
);

export default MTPWarning;
